/**
 * A leitura por imagem do documento sem camada de texto, na tela (E101.F5.T01, ADR-0085 §2.6).
 *
 * O documento só em imagem é lido fora da requisição (E101.F1): aguardando, lendo, lido ou não lido.
 * A marca fica ao lado do nome do documento; o documento com texto não ganha marca. O aviso de
 * leitura em andamento aparece enquanto o processamento do caso espera a leitura terminar.
 */
import { Badge } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { EstadoDaLeituraPorImagem, MotivoDaFalhaDaLeitura } from '@/lib/case_source_documents';

const t = ptBR.exameEletronico.leituraPorImagem;

const VARIANTE = {
  pendente: 'neutral',
  lendo: 'info',
  concluida: 'outline',
  falhou: 'warning',
} as const;

export function LeituraPorImagemBadge({
  docId,
  estado,
  motivo,
}: {
  docId: string;
  estado: EstadoDaLeituraPorImagem | null | undefined;
  motivo?: MotivoDaFalhaDaLeitura | null | undefined;
}): JSX.Element | null {
  if (estado === null || estado === undefined) return null;
  const rotulo = t.estado[estado];
  const detalhe =
    estado === 'falhou' && motivo !== null && motivo !== undefined
      ? t.motivo[motivo]
      : estado === 'concluida'
        ? t.dicaConcluida
        : null;
  return (
    <span className="inline-flex flex-wrap items-center gap-sc-1">
      <Badge
        variant={VARIANTE[estado]}
        data-testid={`peca-leitura-${docId}`}
        data-estado={estado}
        aria-label={t.aria.replace('{estado}', rotulo)}
      >
        {rotulo}
      </Badge>
      {detalhe === null ? null : (
        <span className="text-caption text-fg-dim" data-testid={`peca-leitura-detalhe-${docId}`}>
          {detalhe}
        </span>
      )}
    </span>
  );
}

export function LeituraPorImagemEmAndamento({ ativa }: { ativa: boolean }): JSX.Element | null {
  if (!ativa) return null;
  return (
    <div
      className="mt-sc-4 border border-accent-200 bg-accent-bg px-sc-3 py-sc-2 text-body-sm text-accent-800"
      role="status"
      data-testid="leitura-por-imagem-em-andamento"
    >
      <p className="font-semibold">{t.emAndamentoTitulo}</p>
      <p className="mt-1">{t.emAndamento}</p>
    </div>
  );
}
